"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStrategyTreeFiltering = void 0;
const react_1 = require("react");
const graphql_1 = require("../../../../__generated__/graphql");
const react_redux_1 = require("react-redux");
const product_tree_nodes_1 = require("../../../client/product-tree-nodes");
const client_constants_1 = require("../../../client/client.constants");
const catalogs_1 = require("../../../store/catalogs");
const selected_l1_categories_1 = require("../../../store/shared/selected-l1-categories");
const store_1 = require("../../../../store");
const useStrategyTreeFiltering = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const selectedProductTreeId = (0, store_1.useProductTreeId)();
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const { getTreeNodePaths } = (0, product_tree_nodes_1.useTreeNodePaths)();
    const { extendedFilter } = (0, catalogs_1.useSelectedL1CategoriesAndTerminalNodesData)();
    // State needed to persist tree node paths across renders and make them accessible to allowedNodeIds memo
    const [treeNodePaths, setTreeNodePaths] = (0, react_1.useState)([]);
    const allowedL1Ids = (0, react_1.useMemo)(() => {
        if (!(extendedFilter === null || extendedFilter === void 0 ? void 0 : extendedFilter.length))
            return undefined;
        const l1Ids = [];
        extendedFilter.forEach(({ id }) => {
            if (id) {
                l1Ids.push(id);
            }
        });
        return l1Ids;
    }, [extendedFilter]);
    const allowedNodeIds = !treeNodePaths.length ? undefined : [...treeNodePaths];
    const applyFiltering = (0, react_1.useCallback)((selection) => __awaiter(void 0, void 0, void 0, function* () {
        // If nothing is selected, revert to the unfiltered tree
        if (!selection.length) {
            setTreeNodePaths([]);
            return;
        }
        const partiallySelectedNodeIds = [];
        selection.forEach(({ children: terminalNodes }) => {
            if (terminalNodes && terminalNodes.length > 0) {
                partiallySelectedNodeIds.push(...terminalNodes);
            }
        });
        let treeNodePathsData = [];
        if (partiallySelectedNodeIds.length > 0) {
            const { data } = yield getTreeNodePaths({
                variables: {
                    productTreeId: selectedProductTreeId,
                    sort: [{ distance: graphql_1.SortOrder.Asc }],
                    filter: { id: { in: partiallySelectedNodeIds } },
                    first: client_constants_1.REQUEST_LIMIT_MEDIUM,
                },
            });
            treeNodePathsData = data || [];
        }
        setTreeNodePaths(treeNodePathsData);
        if (treeNodePathsData.length > 0) {
            dispatch((0, store_1.enrichAISetExpandedNodes)(treeNodePathsData));
        }
    }), [getTreeNodePaths, selectedProductTreeId, dispatch]);
    const handleCategorySelectionChanged = (0, react_1.useCallback)((selection) => __awaiter(void 0, void 0, void 0, function* () {
        let categoriesToSelect = selection;
        // Convert from GroupedOption to SelectedCategory if needed
        if (Array.isArray(selection) && (0, selected_l1_categories_1.isGroupedOptionArray)(selection)) {
            categoriesToSelect = selection.map(selected_l1_categories_1.convertGroupedOptionToCategory);
        }
        // detect removed ids and clear any forced visibility for them
        const prevIds = (extendedFilter || []).map((c) => c.id);
        const nextIds = (categoriesToSelect || []).map((c) => c.id);
        const removed = prevIds.filter((id) => id && !nextIds.includes(id));
        removed.forEach((id) => {
            if (id) {
                dispatch((0, catalogs_1.removeFromExclusiveFilterForProductTreeTaxonomy)(selectedCatalogId, id));
            }
        });
        dispatch((0, catalogs_1.setTreeNodeFilteringStateForProductTreeTaxonomy)(selectedCatalogId, { extendedFilter: categoriesToSelect }));
        yield applyFiltering(categoriesToSelect);
    }), [
        dispatch,
        selectedCatalogId,
        applyFiltering,
        extendedFilter,
    ]);
    // Apply filtering on mount if there are persisted selections
    (0, react_1.useEffect)(() => {
        if (extendedFilter && extendedFilter.length > 0) {
            void applyFiltering(extendedFilter);
        }
        else if (extendedFilter && extendedFilter.length === 0) {
            // Handle case where Redux has empty array (user cleared selection)
            setTreeNodePaths([]);
        }
    }, [extendedFilter, applyFiltering, dispatch]);
    return {
        selectedCategories: extendedFilter || [],
        allowedL1Ids,
        allowedNodeIds,
        handleCategorySelectionChanged,
        applyFiltering,
    };
};
exports.useStrategyTreeFiltering = useStrategyTreeFiltering;
exports.default = exports.useStrategyTreeFiltering;
